import * as React from 'react';
import { SxProps, Theme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../icon-button/IconButton';

interface BackButtonProps {
  /** Domyslnie `navigate(-1)`. */
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

/**
 * Jedyny przycisk "wroc" w panelu. Wczesniej kazdy ekran mial swoja wersje —
 * goly arrow z MUI, arrow 2rem w kolorze tekstu, ten sam przycisk bez etykiety
 * na mobile — dlatego wyglada to teraz z jednego miejsca.
 *
 * Sama strzalka, bez widocznej etykiety: przycisk stoi tuz przy tytule strony,
 * ktory i tak mowi, gdzie jestesmy, a slowo "WROC" obok naglowka konkurowalo
 * z nim o uwage. Nazwa dostepna zostaje w `ariaLabel` — dla czytnika ekranu nic
 * sie nie zmienia. (Wczesniej etykieta byla celowo zawsze widoczna; ta decyzja
 * zostala odwrocona.)
 */
export const BackButton: React.FC<BackButtonProps> = ({ onClick, sx }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    /* Bez `label` IconButton przelacza sie w tryb icon-only: kwadratowy hit area
       i zerowy margines przy ikonie. Zadnego wlasnego `px` — nadpisywaloby ten
       kwadrat i robilo z hoveru waski prostokat. */
    <IconButton
      icon={<ArrowBackIcon />}
      ariaLabel={t('common.back')}
      onClick={onClick ?? (() => navigate(-1))}
      sx={sx}
    />
  );
};

export default BackButton;
